import React, { Component } from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { _getNextNumber, _generateId } from './utils';
// Icons
import { IoMdAdd as AddIcon } from 'react-icons/io';
// Components
import CardsList from './CardsList';
import Form from './Form';

class Board extends Component {
  constructor(props) {
    super(props);

    this.state = {
      lists: {},
      cards: {},
      listOrder: [],
      projectId: null,
      newListText: '',
      creatingNewList: false,
      openMenuId: null
    };

    this.handleAddCard = this.handleAddCard.bind(this);
    this.handleRemoveCard = this.handleRemoveCard.bind(this);
    this.handleAddList = this.handleAddList.bind(this);
    this.handleRemoveList = this.handleRemoveList.bind(this);
    this.handleRemoveAllCards = this.handleRemoveAllCards.bind(this);
    this.handleCopyList = this.handleCopyList.bind(this);
    this.renderLists = this.renderLists.bind(this);
    this.handleMoveAllCards = this.handleMoveAllCards.bind(this);
    this.handleToggleMenu = this.handleToggleMenu.bind(this);
    this.handleCopyCard = this.handleCopyCard.bind(this);
    this.handleEditCard = this.handleEditCard.bind(this);
    this.handleRemoveTag = this.handleRemoveTag.bind(this);
    this.handleAddTag = this.handleAddTag.bind(this);
    this.handleDragEnd = this.handleDragEnd.bind(this);
  }

  componentDidMount() {
    // Init state with data
    this.setState({
      lists: this.props["project"].lists,
      cards: this.props["project"].cards,
      listOrder: this.props["project"].listOrder,
      projectId: Number(this.props.projectId),
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props["project"] !== prevProps["project"]) {
      this.setState({
        lists: this.props["project"].lists,
        cards: this.props["project"].cards,
        listOrder: this.props["project"].listOrder,
        projectId: Number(this.props.projectId),
      });
    }
    // console.log(this.props["project"] !== prevProps["project"])
    // console.log(prevProps["project"])

  }

  handleDragEnd({ destination, source, draggableId, type }) {
    // Drop out of the droppable context
    if (!destination) {
      return;
    }
    // Drop in the exact same place
    if (destination.droppableId === source.droppableId &&
      destination.index === source.index) {
      return;
    }
    // Re-order cards inside the list
    if (type === "card") {
      const lists = { ...this.state.lists };
      lists[source.droppableId].cardids.splice(source.index, 1);
      lists[destination.droppableId].cardids.splice(destination.index, 0, draggableId);
      this.setState({ lists });
    }
    // Re-order lists inside the board
    if (type === "list") {
      const listOrder = [...this.state.listOrder];
      listOrder.splice(source.index, 1);
      listOrder.splice(destination.index, 0, draggableId);
      this.setState({ listOrder });
    }
  }

  handleAddList(title = '') {
    if (title.trim()) {
      let lists = { ...this.state.lists };
      let listOrder = [...this.state.listOrder];
      // Get Id for this new list
      const id = _generateId();
      // Add the new list
      lists[id] = { id, title, cardids: [] };
      listOrder.push(id);

      // Save into database
      fetch('https://warm-waters-06754.herokuapp.com/lists', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem("token")),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ title, id: this.state.projectId })
      }).then((response) => response.json())
        .then((data) => {
          console.log(data)
        })
        .catch((e) => {
          console.log(e)
        });

      // Update state
      this.setState({ lists, listOrder, newListText: '', creatingNewList: false });
    }
    else {
      // Reset
      this.setState({ newListText: '', creatingNewList: false });
    }
  }

  handleRemoveList(listId) {
    let lists = { ...this.state.lists };
    let cards = { ...this.state.cards };
    let listOrder = [...this.state.listOrder];
    // Delete all cards from this list
    for (let cardId in lists[listId].cardids) {
      delete cards[cardId];
    }
    // Delete list itself
    delete lists[listId];
    const index = listOrder.indexOf(listId);
    if (index !== -1) {
      listOrder.splice(index, 1);
    }
    // Update state
    this.setState({ lists, cards, listOrder });
  }

  handleAddCard(listId, description = '') {
    if (!description.trim()) {
      return;
    }
    let lists = { ...this.state.lists };
    let cards = { ...this.state.cards };
    // Get Id for this new card
    const id = _generateId();
    const number = _getNextNumber(cards);
    // Add the new card
    cards[id] = { id, number, description, tags: [] };
    lists[listId].cardids.push(id);

    // Save into database
    fetch('https://warm-waters-06754.herokuapp.com/issues', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem("token")),
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ description, projectId: this.state.projectId, uuid: listId })
    }).then((response) => response.json())
      .then((data) => {
        console.log(data)
      })
      .catch((e) => {
        console.log(e)
      });

    // Update state
    this.setState({ lists, cards });
  }

  handleRemoveCard(listId, cardId) {
    let lists = { ...this.state.lists };
    let cards = { ...this.state.cards };
    // Delete card
    delete cards[cardId];
    // Remove card Id from the corresponding list
    const index = lists[listId].cardids.indexOf(cardId);
    if (index !== -1) {
      lists[listId].cardids.splice(index, 1);
    }
    // Update state
    this.setState({ lists, cards });
  }

  handleRemoveAllCards(listId) {
    let lists = { ...this.state.lists };
    let cards = { ...this.state.cards };
    // Delete all cards from the corresponding list
    for (let cardId in lists[listId].cardids) {
      delete cards[cardId];
    }
    // Remove card Ids from the list
    lists[listId].cardids = [];
    // Update state
    this.setState({ cards, lists, openMenuId: null });
  }

  handleCopyCard(listId, cardId) {
    let lists = { ...this.state.lists };
    let cards = { ...this.state.cards };
    // Create card copy
    const id = _generateId();
    const number = _getNextNumber(cards);
    cards[id] = { id, number, description: cards[cardId].description, tags: [...cards[cardId].tags] };
    // Add it to the list
    lists[listId].cardids.push(id);
    this.setState({ cards, lists });
  }

  handleCopyList(listId) {
    let lists = { ...this.state.lists };
    let cards = { ...this.state.cards };
    let listOrder = [...this.state.listOrder];
    let cardids = [];
    // Copy all cards from list to copy
    for (let i = 0; i < lists[listId].cardids.length; i++) {
      const id = _generateId();
      const number = _getNextNumber(cards);
      const cardId = lists[listId].cardids[i];
      cardids.push(id);
      cards[id] = { id, number, description: cards[cardId].description, tags: [...cards[cardId].tags] };
    }
    // Copy list with Ids for the new copy cards
    const id = _generateId();
    lists[id] = { id, title: '(Copy) - ' + lists[listId].title, cardids };
    listOrder.push(id);
    // Update state
    this.setState({ cards, lists, listOrder, openMenuId: null });
  }

  handleMoveAllCards(listId) {
    let lists = { ...this.state.lists };
    let cardids = [];
    // Update the lists
    for (let id in lists) {
      if (id !== listId) {
        // Source list
        cardids.push(...lists[id].cardids);
        lists[id].cardids = [];
      }
    }
    // Target list
    lists[listId].cardids.push(...cardids);
    // Update state
    this.setState({ lists, openMenuId: null });
  }

  handleToggleMenu(listId) {
    this.setState({ openMenuId: this.state.openMenuId === listId ? null : listId });
  }

  handleEditCard(cardId, description = '') {
    let cards = { ...this.state.cards };
    // Update card description
    cards[cardId].description = description;
    // Update state
    this.setState({ cards });
  }

  handleRemoveTag(cardId, tagId) {
    let cards = { ...this.state.cards };
    // Remove tag from card
    if (cards[cardId]) {
      cards[cardId].tags.splice(tagId, 1);
    }
    // Update state
    this.setState({ cards });
  }

  handleAddTag(cardId, text) {
    let cards = { ...this.state.cards };

    text = text.trim().toLowerCase()

    // Add tag to the corresponding card
    if (cards[cardId] && text) {
      cards[cardId].tags.forEach((tag) => {
        if (!tag === text) {
          cards[cardId].tags.push(text);

          // Save into database
          fetch('https://warm-waters-06754.herokuapp.com/issues', {
            method: 'PATCH',
            headers: {
              'Accept': 'application/json',
              'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem("token")),
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({ text, cardId })
          }).then((response) => response.json())
            .then((data) => {
              console.log(data)
            })
            .catch((e) => {
              console.log(e)
            });
        }
      })
    }

    // Update state
    this.setState({ cards });
  }

  renderLists() {
    return (
      <Droppable
        droppableId="all-lists"
        direction="horizontal"
        type="list"
      >
        {(provided) => (
          <ul className="board-lists"
            ref={provided.innerRef}
            {...this.props.droppableProps}
          >
            {
              this.state.listOrder.map((listId, index) => {
                const list = this.state.lists[listId];
                if (!list.cardids) { list.cardids = [] }
                const cards = list.cardids.map(key => this.state.cards[key]);
                return (
                  <li key={list.id}>
                    <CardsList
                      id={list.id}
                      index={index}
                      title={list.title}
                      cards={cards}
                      isMenuOpen={this.state.openMenuId === list.id}
                      onToggleMenu={this.handleToggleMenu}
                      onAddCard={this.handleAddCard}
                      onRemoveCard={this.handleRemoveCard}
                      onRemoveList={this.handleRemoveList}
                      onRemoveAllCards={this.handleRemoveAllCards}
                      onCopyList={this.handleCopyList}
                      onMoveAllCards={this.handleMoveAllCards}
                      onCopyCard={this.handleCopyCard}
                      onEditCard={this.handleEditCard}
                      onRemoveTag={this.handleRemoveTag}
                      onAddTag={this.handleAddTag}
                    />
                  </li>
                );
              })
            }
            {provided.placeholder}
          </ul>
        )}
      </Droppable>
    );
  }

  renderNewList() {
    return (
      this.state.creatingNewList
        ? <Form
          type="list"
          placeholder="Enter a title for this list..."
          buttonText="Add List"
          onClickSubmit={this.handleAddList}
          onClickCancel={() => this.setState({ creatingNewList: false })}
        />
        : <button
          className="add-button"
          onClick={() => this.setState({ creatingNewList: true })}
        >
          <AddIcon />
          <p>Add a new list</p>
        </button>
    );
  }

  render() {
    return (
      <DragDropContext
        onDragEnd={this.handleDragEnd}
        onDragStart={this.handleDragStart}
        onDragUpdate={this.handleDragUpdate}
      >
        <div className="board">
          {this.renderLists()}
          {this.renderNewList()}
        </div>
      </DragDropContext>
    );
  }
};

export default Board;